export default __webpack_public_path__ + "static/media/369.66569e0d.png";